import { useGetClassPasswordApi } from 'eds-common/api/v1';
import redemptionSuccessBanner from '@/assets/images/redemption-success-banner.jpg';
import { useAccessCodeRedemptionContext } from './AccessCodeRedemptionContext';
import { RedemptionSuccessActions } from './RedemptionSuccessActions';
import { ClassroomPasswordInput } from '../ClassroomPasswordDisplay/ClassroomPasswordInput';

export function MyScholasticRedemptionSuccess() {
  const { redemptionData } = useAccessCodeRedemptionContext();
  const { data: classPassword, isLoading } = useGetClassPasswordApi();

  if (isLoading || !classPassword || !redemptionData.product) {
    return null;
  }

  return (
    <div className="flex flex-col">
      <img
        src={redemptionSuccessBanner}
        alt=""
        className="h-[161px] w-full object-cover"
      />
      <h2 className="px-8 pb-4 pt-6 text-3xl font-bold text-neutral-1300">
        Setup complete!
      </h2>
      <div className="flex flex-col gap-6 px-8 text-lg text-neutral-900">
        <p>
          You now have access to{' '}
          <strong className="font-bold">
            {redemptionData.product.productName}!
          </strong>
        </p>
        <p>
          Direct your students to use the shared classroom password to access
          all of your purchased products. You can change this password at any
          time.
        </p>
        <div className="max-w-[510px]">
          <ClassroomPasswordInput
            classPassword={classPassword}
            successMessage={null}
          />
        </div>
      </div>

      <RedemptionSuccessActions />
    </div>
  );
}
